var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-8"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('span',[_vm._v("\n        saindo...\n      ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }